import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/index')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/views/audit/index')
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('@/views/home/userAgreement')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@/views/home/privacy')
    },
    {
      path: '/goods/:id',
      name: 'Goods',
      component: () => import('@/views/goods/index')
    },
    {
      path: '/cart',
      name: 'Cart',
      component: () => import('@/views/cart/index')
    },
    {
      path: '/orderCreate',
      name: 'OrderCreate',
      component: () => import('@/views/orderCreate/index')
    },
    {
      path: '/order/list',
      name: 'OrderList',
      component: () => import('@/views/orderList/index')
    },
    {
  path: '/goodsList',
  name: 'GoodsList',
  component: () => import('@/views/goodsList/index')
},
// 在路由配置数组中新增该项
{
  path: '/user',
  name: 'User',
  component: () => import('@/views/user/index.vue'),
  meta: { title: '个人中心' }
},
    {
      path: '/merchantJoin',
      name: 'MerchantJoin',
      component: () => import('@/views/merchantJoin/index')
    },
    {
  path: '/merchantList',
  name: 'MerchantList',
  component: () => import('@/views/merchantList/index')
},
    {
  path: '/merchant/:id',
  name: 'MerchantDetail',
  component: () => import('@/views/merchant/index')
},
{
  path: '/customer-service',
  name: 'CustomerService',
  component: () => import('@/views/customerService/index.vue')
},
{
  path: '/rider-apply',
  name: 'RiderApply',
  component: () => import('@/views/riderApply/index.vue')
},
    {
      path: '*',
      redirect: '/'
    }
  ]
})
